import React, { useState, useEffect } from 'react';
import './Dashboard.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function Dashboard() {
  const [stats, setStats] = useState({
    totalSubmissions: 0,
    todaySubmissions: 0,
    recentSubmissions: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    const token = localStorage.getItem('admin_token');
    
    try {
      const response = await fetch(`${API_URL}/submissions?limit=5`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        
        // Calculate today's submissions
        const today = new Date().toDateString();
        const todayCount = data.submissions.filter(sub => 
          new Date(sub.created_at).toDateString() === today
        ).length;

        setStats({
          totalSubmissions: data.pagination.total,
          todaySubmissions: todayCount,
          recentSubmissions: data.submissions
        });
      }
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-MY', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <div className="dashboard">
      {/* Stats Cards */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon total">📝</div>
          <div className="stat-content">
            <h3>Total Submissions</h3>
            <p className="stat-value">{stats.totalSubmissions}</p>
          </div>
        </div>
        
        <div className="stat-card">
          <div className="stat-icon today">📅</div>
          <div className="stat-content">
            <h3>Today's Submissions</h3>
            <p className="stat-value">{stats.todaySubmissions}</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon status">✅</div>
          <div className="stat-content">
            <h3>System Status</h3>
            <p className="stat-value online">Online</p>
          </div>
        </div>
      </div>

      {/* Recent Submissions */}
      <div className="card recent-submissions">
        <div className="card-header">
          <h2>Recent Submissions</h2>
          <a href="/submissions" className="view-all">View All →</a>
        </div>
        
        {stats.recentSubmissions.length > 0 ? (
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Bank</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {stats.recentSubmissions.map((submission) => (
                  <tr key={submission.id}>
                    <td>{submission.name}</td>
                    <td>{submission.phone}</td>
                    <td>{submission.bank}</td>
                    <td>{formatDate(submission.created_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="empty-state">
            <span className="empty-icon">📭</span>
            <p>No submissions yet</p>
          </div>
        )}
      </div>

      {/* Quick Links */}
      <div className="quick-links">
        <h2>Quick Actions</h2>
        <div className="links-grid">
          <a href="/settings" className="quick-link">
            <span className="link-icon">⚙️</span>
            <span>Edit Page Settings</span>
          </a>
          <a href="/submissions" className="quick-link">
            <span className="link-icon">📋</span>
            <span>View All Submissions</span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;

